import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaUser } from "react-icons/fa";
import Loader from "../components/loader";
import "./OwnerSignup.css";
import emailjs from "@emailjs/browser";
import { v4 as uuidv4 } from "uuid";

export default function  OwnerSignup() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showVerifyModal, setShowVerifyModal] = useState(false);
const [verificationToken, setVerificationToken] = useState(null);
const [timer, setTimer] = useState(30);
const [canResend, setCanResend] = useState(false);

useEffect(() => {
  let interval;
  if (showVerifyModal && timer > 0) {
    interval = setInterval(() => setTimer((t) => t - 1), 1000);
  } else if (timer === 0) {
    setCanResend(true);
  }
  return () => clearInterval(interval);
}, [showVerifyModal, timer]);

const handleResend = async () => {
  if (!canResend) return;

  setTimer(30);
  setCanResend(false);

  await sendVerificationEmail(
    formData.name,
    formData.email,
    verificationToken
  );
};



const sendVerificationEmail = async (name, email, token) => {
  const link = `${window.location.origin}/Owner/verify-handler/${token}`;

  const templateParams = {
    to_name: name,
    user_email: email,
    verification_link: link,
  };

  await emailjs.send(
    "service_5u1kekh",
    "template_3j87dpi",
    templateParams,
    "5C9M_B-DFS8qIhtRl"
  );
};


  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const userId = uuidv4().replace(/-/g, "").slice(0, 16);

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/owner/signup`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, userId }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      setError(data.message || "Signup failed");
      setLoading(false);
      return;
    }
    

    // ✅ EMAIL VERIFICATION FLOW
  if (data.verificationToken) {
  setVerificationToken(data.verificationToken);

  // ✅ STORE CONTEXT
  localStorage.setItem("verificationRole", "owner");
  localStorage.setItem("verificationEmail", formData.email);

  await sendVerificationEmail(
    formData.name,
    formData.email,
    data.verificationToken
  );

  setShowVerifyModal(true);
}


  } catch (err) {
    setError("Something went wrong");
  }

  setLoading(false);
};

  if (loading) return <Loader />;

  return (
  <div className="owner-auth-wrapper">

    {/* ================= VERIFY EMAIL MODAL ================= */}
    {showVerifyModal && (
      <div className="verify-modal-content-x">
        <h3>Email Verification</h3>
        <p>Verification link sent to {formData.email}</p>

        <button
          disabled={!canResend}
          onClick={handleResend}
          className="owner-auth-btn"
        >
          {canResend ? "Resend Email" : `Resend (${timer}s)`}
        </button>
      </div>
    )}

    {/* ================= OWNER SIGNUP FORM ================= */}
    {!showVerifyModal && (
      <form className="owner-auth-card" onSubmit={handleSubmit}>
        <h2 className="owner-auth-title">Owner Signup</h2>

        <div className="owner-auth-input">
          <FaUser />
          <input
            name="name"
            placeholder="Owner Name"
            onChange={handleChange}
            required
          />
        </div>

        <div className="owner-auth-input">
          <FaEnvelope />
          <input
            name="email"
            type="email"
            placeholder="Owner Email"
            onChange={handleChange}
            required
          />
        </div>

        <div className="owner-auth-input">
          <FaLock />
          <input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />
        </div>

        <div className="owner-auth-input">
          <FaLock />
          <input
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            required
          />
        </div>

        {error && <p className="owner-auth-error">{error}</p>}

        <button className="owner-auth-btn">Create Account</button>
        <p className="owner-auth-footer">
          Already have an Owner account?{" "}
          <br/>
          <span
            className="owner-auth-link"
            onClick={() => navigate(`/Owner/login/${process.env.REACT_APP_OWNER_PATH}/en-list/owner`)}
          >
            Click here to Login
          </span>
        </p>
      </form>
    )}

  </div>
);

}
